<template>
  <b-row>
    <b-col>
      <b-card>
        <h5 class="mb-4">
          <strong>Cuentas</strong>
        </h5>
        <!-- Columnas donde se encuentran los selectores -->
        <b-row class="overflow-auto" style="min-height: 80vh; max-height: 80vh;">
          <b-col v-show="selectors[index]" :class="getResponsiveClass(index)" sm="9" :md="getResponsiveSize(index)" v-for="(type, index) of lists" :key="index" style="height: 80vh; transition: 0.5s;">
            <b-row class="mb-3">
              <b-col><b>{{ desiredText[index][0].toUpperCase() + desiredText[index].slice(1).toLowerCase() }}</b></b-col>
            </b-row>
            <b-form-input
              id="input-live"
              v-model="filters[index]"
              aria-describedby="input-live-help input-live-feedback"
              :placeholder="getPlaceHolder(index)"
              trim
              :class="!(selectors.subAccounts && !nonSelectables.includes(index)) ? 'mb-2' : 'mb-2 magic-trick'"
              v-show="selectors[index] && lists[index].length > 0"
            ></b-form-input>
            <b-row align-v="center" v-show="selectors[index]" v-for="(xClass, newIndex) of lists[index]" :key="newIndex" style="border-bottom: 1px solid #F2F3F4;" >
              <b-col class="mx-2 my-1">
                <span class="btn-link prevent-select" style="cursor: pointer; color: #595c97;" @click="searchBy(xClass)">
                  <b>{{ getContent(xClass, index) }}</b>
                </span>
              </b-col>
              <b-col v-if="xClass.level >=  6">
                <i v-if="xClass.level >=  6" class="btn btn-light py-0 fa fa-plus text-success ml-2" style="cursor: pointer;" @click="openModal(xClass, index)" />
                <i v-if="xClass.level >=  6" class="btn btn-light py-0 fa fa-pencil ml-2" style="cursor: pointer;" @click="openModal(xClass)" />
                <i v-if="xClass.level >=  6" class="btn btn-light py-0 fa fa-trash text-red ml-2" style="cursor: pointer;" @click="deletePUC(xClass, index)" />
              </b-col>
            </b-row>
            <b-row v-if="lists[index].length < 1">
              <b-col>
                <span>
                  <b>No existen cuentas relacionas.</b>
                </span>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <!-- Modal para crear/editar sub-cuentas/cuentas auxiliares/ sub-cuentas auxiliares -->
    <b-modal id="stuffing" ref="modal" title="Crear cuenta" size="lg" hide-footer @hidden="cleanFields()">
      <ValidationObserver ref="observer">
        <b-table id="table-periods-payrolls" striped hover :fields="columns"
          :items="arrayPUC" head-variant="light" responsive>
          <template #cell(name)="puc">
            <b-col v-if="puc.item.isCreating">
              <validation-provider
                name="Nombre"
                :rules="{ required: true }"
                v-slot="validationContext"
              >
                <b-form-group :id="`nombre-${puc.item.category}`" class="mb-0" :invalid-feedback="validationContext.errors[0]">
                  <b-form-input :id="`puc-nombre-${puc.item.level}`" v-model="puc.item.name"
                  placeholder="Nombre"
                  :state="getValidationState(validationContext)"
                  ></b-form-input>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col v-else>
              {{ puc.item.name }}
            </b-col>
          </template>
          <template #cell(value)="puc">
            <b-col v-if="puc.item.isCreating">
              <validation-provider
                name="Código"
                :rules="{ required: true, integer: true, max: (puc.item.category === 'Sub-cuenta auxiliar') ? 4 : 2, min: 2 }"
                v-slot="validationContext"
              >
                <b-form-group :id="`value-${puc.item.category}`" class="mb-0" :invalid-feedback="validationContext.errors[0]">
                  <b-form-input :id="`puc-value-${puc.item.level}`" v-model="puc.item.value"
                  placeholder="Código"
                  :state="getValidationState(validationContext)"
                  ></b-form-input>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col v-else>
              {{ puc.item.value }}
            </b-col>
          </template>
        </b-table>
        <b-row align-h="end">
          <b-col md="3">
            <b-button @click="$bvModal.hide('stuffing')" variant="secondary" size="sm"
              class="mb-3 mt-3">Cancelar</b-button>
            <b-button @click="savePUC()" variant="primary" class="mr-2 mb-3 mt-3">Guardar</b-button>
          </b-col>
        </b-row>
      </ValidationObserver>
    </b-modal>
  </b-row>
</template>

<script>
// import RequiredFields from '@/components/custom/form/RequiredFields.vue'
import breakpoints from '@/services/utilities/breakpoint.js'
import apiClient2 from '@/services/axios/v2.js'
import { mapState } from 'vuex'
import Swal from 'sweetalert2'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 6000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export default {
  name: 'accrualSettings',
  components: {
    // RequiredFields,
  },
  data() {
    return {
      levels: {
        1: 'groups',
        2: 'accounts',
        4: 'subAccounts',
        6: 'auxAccounts',
        8: 'subAuxAccounts',
      },
      desiredText: {
        classes: 'clase',
        groups: 'grupo',
        accounts: 'cuenta',
        subAccounts: 'sub-cuenta',
        auxAccounts: 'cuenta auxiliar',
        subAuxAccounts: 'sub-cuenta auxiliar',
      },
      wereSelected: ['classes'],
      nonSelectables: ['subAccounts', 'auxAccounts', 'subAuxAccounts'],
      selectedPUC: {},
      filters: {
        classes: '',
        groups: '',
        accounts: '',
        subAccounts: '',
        auxAccounts: '',
        subAuxAccounts: '',
      },
      selectors: {
        classes: true,
        groups: false,
        accounts: false,
        subAccounts: false,
        auxAccounts: false,
        subAuxAccounts: false,
      },
      lists: {
        classes: [],
        groups: [],
        accounts: [],
        subAccounts: [],
        auxAccounts: [],
        subAuxAccounts: [],
      },
      columns: [
        { key: 'category', label: 'Categoría' },
        { key: 'name', label: 'Nombre' },
        { key: 'value', label: 'Código' },
      ],
      pagination: {
        rows: 0,
        perPage: 10,
        currentPage: 1,
      },
    }
  },
  computed: {
    ...mapState(['user']),
    arrayPUC: function() {
      const levels = [
        'classes', 'groups', 'accounts', 'subAccounts', 'auxAccounts', 'subAuxAccounts',
      ]
      const arrayPUC = []
      for (const level of levels) {
        if (this.selectedPUC[level]) {
          arrayPUC.push(this.selectedPUC[level])
        }
      }
      return arrayPUC
    },
    breakpoints: () => breakpoints.screen,
  },
  // Inicial
  created() {
    this.getPUCs()
      .then(() => {
      })
      .catch((error) => {
        console.error('Ha ocurrido un error:', error)
      })
  },
  methods: {
    getPUCs() {
      return new Promise((resolve, reject) => {
        apiClient2.get('/puc/classes')
          .then((response) => {
            const { data } = response.data
            this.lists.classes = data.map((e) => { return { id: e.id, name: e.name, completeCode: e.completeCode, level: e.level } })
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getResponsiveClass(index) {
      let returnedClass = 'border-right'
      returnedClass += (!this.nonSelectables.includes(index) && (breakpoints.screen.sm || breakpoints.screen.xs)) ? '' : ' overflow-auto'
      return returnedClass
    },
    getResponsiveSize(index) {
      console.log(index, 'index?')
      let size = 4
      let counter = -3
      const stuff = ['subAccounts', 'auxAccounts', 'subAuxAccounts']
      const levels = {
        classes: 1,
        groups: 1,
        accounts: 1,
        subAccounts: 1,
        auxAccounts: 1,
        subAuxAccounts: 1,
      }
      for (const type in this.selectors) {
        if (this.selectors[type]) {
          counter += levels[type]
        }
      }
      size = (counter > 0) ? 1 : 'auto'
      if (stuff.includes(index)) {
        size = 'auto'
      }
      return size
    },
    getContent(xClass, index) {
      let text = `${xClass.completeCode} - ${xClass.name}`
      if (this.selectors.subAccounts && !(breakpoints.screen.sm || breakpoints.screen.xs)) {
        text = (!this.nonSelectables.includes(index)) ? `• ${xClass.completeCode}` : text
      }
      return text
    },
    getPlaceHolder(index) {
      const text = 'Buscar'
      return `${text} ${this.desiredText[index]}`
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
    searchBy(puc) {
      console.log(puc, 'here')
      if (puc.level >= 10) {
        return
      }
      const links = {
        1: `puc/classes/${puc.id}/groups/`,
        2: `puc/classes/groups/${puc.id}/accounts`,
        4: `puc/classes/groups/accounts/${puc.id}/sub-accounts`,
        6: `puc/classes/groups/accounts/sub-accounts/${puc.id}`,
        8: `puc/classes/groups/accounts/sub-accounts/aux-accounts/${puc.id}`,
      }
      apiClient2.get(links[puc.level])
        .then((response) => {
          const { data } = response.data
          this.lists[this.levels[puc.level]] = data.map((e) => { return { id: e.id, name: e.name, completeCode: e.completeCode, level: e.level, idSchool: e.idSchool } })
          let i = (puc.level > 1) ? puc.level + 2 : 2
          for (i; i <= 10; i += 2) {
            if (this.selectors[this.levels[i]] !== undefined) {
              this.selectors[this.levels[i]] = false
            }
          }
          this.selectors[this.levels[puc.level]] = true
        })
        .catch((error) => {
          console.log(error)
        })
      console.log(this.selectors)
    },
    cleanFields() {
      this.selectedPUC = {}
    },
    //
    async savePUC() {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        console.log(this.arrayPUC)
        console.log(this.selectedPUC)
        const sentPUC = {
          name: this.arrayPUC[this.arrayPUC.length - 1].name,
          level: this.arrayPUC[this.arrayPUC.length - 1].level + 2,
          code: this.arrayPUC[this.arrayPUC.length - 1].value,
          idPUC: this.arrayPUC[this.arrayPUC.length - 1].idPUC,
          completeCode: this.arrayPUC.map(item => item.value).join(''),
        }
        apiClient2.post('/puc', sentPUC).then(response => {
          return Toast.fire({
            icon: 'success',
            title: response.data.message,
          })
        })
      } else {
        return Toast.fire({
          icon: 'error',
          title: 'LAIK... WUAT?',
        })
      }
    },
    deletePUC(xClass, index) {
      console.log(index)
      Swal.fire({
        title: 'Confirmar eliminación',
        html: `
            <div>
              <p style="margin:0">¿Estás seguro de eliminar <b>${this.desiredText[index]}</b> <b>${xClass.name}</b>?</p>
            </div>
        `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminar',
        cancelButtonText: 'No',
      }).then(async (result) => {
        if (result.isConfirmed) {
          Toast.fire({
            icon: 'success',
            title: `Eliminación de ${this.desiredText[index]} ${xClass.name} correctamente`,
          })
        }
      })
    },
    async resetForm() {
      this.form.idConceptType = null
      this.form.name = ''
      requestAnimationFrame(() => {
        this.$refs.observer.reset()
      })
    },
    openModal(puc, index) {
      console.log(index)
      console.log(this.selectedPUC, 'sup')
      console.log(puc, 'sup3')
      const levels = {
        1: 'classes',
        2: 'groups',
        4: 'accounts',
        6: 'subAccounts',
        8: 'auxAccounts',
        10: 'subAuxAccounts',
      }
      let spliceCounter = 0
      let shouldBreak = false
      for (const level in levels) {
        if (shouldBreak) {
          this.selectedPUC[levels[level]] = {
            category: this.desiredText[levels[level]][0].toUpperCase() + this.desiredText[levels[level]].slice(1).toLowerCase(),
            name: '',
            value: '',
            level: puc.level,
            idPUC: puc.id,
            isCreating: true,
          }
          break
        }
        const completeCode = this.lists[levels[level]].find(item => item.completeCode === puc.completeCode.slice(0, (spliceCounter > 1) ? spliceCounter + 2 : spliceCounter + 1))
        this.selectedPUC[levels[level]] = {
          category: this.desiredText[levels[level]][0].toUpperCase() + this.desiredText[levels[level]].slice(1).toLowerCase(),
          name: completeCode.name,
          value: puc.completeCode.slice(spliceCounter, (spliceCounter > 1) ? spliceCounter + 2 : spliceCounter + 1),
        }
        spliceCounter += (spliceCounter > 1) ? 2 : 1
        shouldBreak = (level === puc.level.toString())
      }
      this.selectedPUC = { ...this.selectedPUC }
      this.$bvModal.show('stuffing')
    },
    editAccrual(evt) {
      evt.preventDefault()
      apiClient2.put(`/concepts/${this.accrualToEdit.id}`, {
        state: this.accrualToEdit.state,
        name: this.accrualToEdit.name,
      }).then((response) => {
        this.accrualList = this.accrualList.map(x => (x.id === this.accrualToEdit.id) ? this.accrualToEdit : x)
        this.$notification.success({
          message: 'Modificación exitosa',
          description: `Devengado ${this.accrualToEdit['conceptType.name']} actualizado exitosamente`,
        })
        this.accrualToEdit = {}
        this.$bvModal.hide('edit-accrual')
      })
    },
    deleteAccrual(accrual) {
      this.getByIdAccrual(accrual.id).then((data) => {
        const message = `<p style="margin:0">Se encontraron <b>${data.totalPayrolls}</b> nóminas registradas con este devengado</p>`
        Swal.fire({
          title: 'Confirmar eliminación',
          html: `
              <div>
                <p style="margin:0">¿Estás seguro de eliminar el devengado <b>${accrual['conceptType.name']}</b>?</p>
                ${data.totalPayrolls > 0 ? message : ''}
                <span style="color:gray; font-size:11px">Nota: Si quieres que no te aparezca en la plantilla excel desactivalo en el bóton editar.</span>
              </div>
          `,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, eliminar',
          cancelButtonText: 'No',
        }).then(async (result) => {
          if (result.isConfirmed) {
            apiClient2.delete(`/concepts/${accrual.id}`).then(response => {
              this.accrualList = this.accrualList.filter(item => item.id !== accrual.id)
              // Add typeAccrual to typeAccrualList
              if (!(this.typesAccruals.find((tp) => tp.value === accrual.idConceptType))) {
                this.typesAccruals.push({
                  text: accrual['conceptType.name'],
                  value: accrual.idConceptType,
                })
                // Sort alphabetically
                this.typesAccruals.sort((a, b) => {
                  const typeAccrualNameA = a.text.toLowerCase()
                  const typeAccrualNameB = b.text.toLowerCase()
                  if (typeAccrualNameA < typeAccrualNameB) {
                    return -1
                  }
                  if (typeAccrualNameA > typeAccrualNameB) {
                    return 1
                  }
                  return 0
                })
              }
              Toast.fire({
                icon: 'success',
                title: `Devengado ${accrual['conceptType.name']} eliminado correctamente`,
              })
            }).catch(e => { console.log(e) })
          }
        })
      }).catch(e => { console.log(e) })
    },
    getByIdAccrual(idAccrual) {
      return new Promise((resolve, reject) => {
        apiClient2.get(`/concepts/${idAccrual}`)
          .then((response) => {
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },
  watch: {
    accrualList: function (value) {
      this.pagination.rows = value.length
    },
  },
}
</script>

<style>

.prevent-select {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

.col-md-4, .col-md-1 {
  -webkit-transition: width 1s ease-in-out;
  -moz-transition: width 1s ease-in-out;
  -o-transition: width 1s ease-in-out;
  transition: width 1s ease-in-out;
}

.clip-it {
  list-style-type: circle;
}

.magic-trick {
  visibility: hidden;
}

</style>
